module.exports = __webpack_public_path__ + "img/40380192.652c8f3d.png";